// client/src/components/seo/SeoRelatedLinks.jsx
import React from "react";
import { Link } from "react-router-dom";

const RELATED_LINKS = {
  qr: {
    de: {
      title: "Weitere Themen zu QR-Code-Speisekarten",
      links: [
        {
          to: "/de/qr-code-speisekarte",
          label: "QR-Code Speisekarte erstellen",
        },
        {
          to: "/de/qr-code-speisekarte-ohne-app",
          label: "QR-Code Speisekarte ohne App",
        },
        {
          to: "/de/qr-code-speisekarte-drucken",
          label: "QR-Code Speisekarte drucken",
        },
        {
          to: "/de/restaurant-qr-code-tischaufsteller",
          label: "Restaurant QR-Code Tischaufsteller",
        },
        {
          to: "/de/digitale-speisekarte-kostenlos-testen",
          label: "Digitale Speisekarte kostenlos testen",
        },
      ],
    },

    en: {
      title: "More topics about QR code menus",
      links: [
        {
          to: "/en/qr-code-menu-for-restaurants",
          label: "QR code menu for restaurants",
        },
        {
          to: "/en/qr-code-menu-without-app",
          label: "QR code menu without app",
        },
        {
          to: "/en/qr-code-menu-printing",
          label: "QR code menu printing",
        },
        {
          to: "/en/restaurant-qr-code-table-tent",
          label: "Restaurant QR code table tent",
        },
        {
          to: "/en/free-digital-menu-test",
          label: "Test a free digital menu",
        },
      ],
    },

    no: {
      title: "Flere temaer om QR-menyer",
      links: [
        {
          to: "/no/digital-meny-for-restauranter",
          label: "Digital meny for restauranter",
        },
        {
          to: "/no/qr-kode-meny-uten-app",
          label: "QR-kode-meny uten app",
        },
        {
          to: "/no/restaurant-qr-kode-bordskilt",
          label: "Restaurant QR-kode bordskilt",
        },
        {
          to: "/no/test-gratis-digital-meny",
          label: "Test en gratis digital meny",
        },
        {
          to: "/no/meny-med-bilder",
          label: "Meny med bilder",
        },
      ],
    },
  },

  menu: {
    de: {
      title: "Weitere Themen zur digitalen Speisekarte",
      links: [
        {
          to: "/de/digitale-speisekarte",
          label: "Digitale Speisekarte für Restaurants",
        },
        {
          to: "/de/speisekarte-online-aendern",
          label: "Speisekarte online ändern",
        },
        {
          to: "/de/tageskarte-digital-erstellen",
          label: "Tageskarte digital erstellen",
        },
        {
          to: "/de/speisekarte-mit-bildern",
          label: "Speisekarte mit Bildern",
        },
        {
          to: "/de/digitale-speisekarte-kostenlos-testen",
          label: "Digitale Speisekarte kostenlos testen",
        },
      ],
    },

    en: {
      title: "More topics about digital menus",
      links: [
        {
          to: "/en/digital-menu-for-restaurants",
          label: "Digital menu for restaurants",
        },
        {
          to: "/en/change-menu-online",
          label: "Change menu online",
        },
        {
          to: "/en/create-digital-daily-menu",
          label: "Create a digital daily menu",
        },
        {
          to: "/en/menu-with-pictures",
          label: "Menu with pictures",
        },
        {
          to: "/en/free-digital-menu-test",
          label: "Test a free digital menu",
        },
      ],
    },

    no: {
      title: "Flere temaer om digitale menyer",
      links: [
        {
          to: "/no/digital-meny-for-restauranter",
          label: "Digital meny for restauranter",
        },
        {
          to: "/no/administrere-meny-online-for-restauranter",
          label: "Administrere meny online",
        },
        {
          to: "/no/meny-med-bilder",
          label: "Meny med bilder",
        },
        {
          to: "/no/test-gratis-digital-meny",
          label: "Test en gratis digital meny",
        },
        {
          to: "/no/digital-meny-pizzeria",
          label: "Digital meny for pizzeriaer",
        },
      ],
    },
  },

  business: {
    de: {
      title: "Weitere digitale Lösungen für Restaurants",
      links: [
        {
          to: "/de/digitale-speisekarte",
          label: "Digitale Speisekarte für Restaurants",
        },
        {
          to: "/de/online-tischreservierung",
          label: "Online-Tischreservierung für Restaurants",
        },
        {
          to: "/de/mehrsprachige-speisekarte",
          label: "Mehrsprachige Speisekarte",
        },
        {
          to: "/de/restaurant-website",
          label: "Restaurant Website erstellen",
        },
        {
          to: "/de/digitales-bestellsystem-gastronomie",
          label: "Digitales Bestellsystem Gastronomie",
        },
      ],
    },

    en: {
      title: "More digital solutions for restaurants",
      links: [
        {
          to: "/en/digital-menu-for-restaurants",
          label: "Digital menu for restaurants",
        },
        {
          to: "/en/online-table-reservation-for-restaurants",
          label: "Online table reservation for restaurants",
        },
        {
          to: "/en/multilingual-menu-for-restaurants",
          label: "Multilingual menu for restaurants",
        },
        {
          to: "/en/restaurant-website-for-restaurants",
          label: "Restaurant website for restaurants",
        },
        {
          to: "/en/digital-ordering-system-for-restaurants",
          label: "Digital ordering system for restaurants",
        },
      ],
    },

    no: {
      title: "Flere digitale løsninger for restauranter",
      links: [
        {
          to: "/no/digital-meny-for-restauranter",
          label: "Digital meny for restauranter",
        },
        {
          to: "/no/online-bordreservasjon-for-restauranter",
          label: "Online bordreservasjon for restauranter",
        },
        {
          to: "/no/administrere-meny-online-for-restauranter",
          label: "Administrere meny online",
        },
        {
          to: "/no/meny-med-bilder",
          label: "Meny med bilder",
        },
        {
          to: "/no/digital-meny-pizzeria",
          label: "Digital meny for pizzeriaer",
        },
      ],
    },
  },
};

export default function SeoRelatedLinks({
  lang = "de",
  group = "menu",
  exclude = "",
}) {
  const safeGroup = RELATED_LINKS[group] ? group : "menu";
  const normalizedLang = String(lang || "").trim().toLowerCase();

  const currentLang = RELATED_LINKS[safeGroup][normalizedLang]
    ? normalizedLang
    : "de";

  const data = RELATED_LINKS[safeGroup][currentLang];
  const links = data.links.filter((item) => item.to !== exclude);

  if (!links.length) return null;

  return (
    <section className="articls qrArticle__related">
      <h2>{data.title}</h2>

      <div className="seoCompareSmall">
        {links.map((item) => (
          <p key={item.to}>
            <Link to={item.to}>{item.label}</Link>
          </p>
        ))}
      </div>
    </section>
  );
}